import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Grid } from '@mui/material';
import { PROGRAMMES_STUDIO_FEATURE_CODE } from '../../services/programmes';
import intro_screen from '../../assets/images/programmes_request_access.png';
import { useUpdateUserProfileMutation } from '../../app/smorgAppSyncGraphQLApi';
import { sendRequestFeatureNotificationOperation } from '../../operations/user_profile_operations';
import { useGetUserProfileQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { currentUserSelector } from '../../features/user_id/user_id_slice';

const ProgrammesRequestAccessPage = () => {
  const [loading, setLoading] = useState(false);

  const featureCode = PROGRAMMES_STUDIO_FEATURE_CODE;

  const { data: userProfile } = useGetUserProfileQuery();

  const { username: userId, email: userEmail } =
    useSelector(currentUserSelector);

  const [updateUserProfile] = useUpdateUserProfileMutation();

  const hasRequestedAccess = (userProfile?.requestedFeatures || []).includes(
    featureCode,
  );

  const handleRequestAccess = async () => {
    if (!userProfile) {
      return null;
    }
    setLoading(true);
    const newRequestedFeatures = [...(userProfile.requestedFeatures || [])];
    if (!newRequestedFeatures.includes(featureCode)) {
      newRequestedFeatures.push(featureCode);
    }
    await sendRequestFeatureNotificationOperation(
      userId,
      userEmail,
      featureCode,
    );
    return updateUserProfile({
      ...userProfile,
      requestedFeatures: newRequestedFeatures,
    });
  };

  return (
    <div className="userProfile">
      <Grid container columnSpacing={1} className="userProfileForm">
        <Grid item xs={12}>
          <div className="programmes_request_access_intro_image">
            <img src={intro_screen} alt="Programs studio" />
          </div>
          <p style={{ fontWeight: 'bold' }}>
            Would you like to create your own health programs and share with
            your clients?
          </p>
          <p>
            Programs studio helps health professionals create and deliver
            personalised health programs at scale.
          </p>

          <p>
            If you would like to find out more about this feature, click the
            button below and we’ll be in touch with more details.
          </p>

          {hasRequestedAccess && (
            <p>
              Thank you for your interest in health programs. We have received
              your request and will be in touch with you soon.
            </p>
          )}
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={handleRequestAccess}
            disabled={loading || hasRequestedAccess}>
            Request access
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProgrammesRequestAccessPage;
